import { detectMobile } from "@config/browser";

export default {
    data() {
        return {
            screenWidth: '',
            baseScreenSmMin: 576,
        }
    },
    computed: {
        tools(){
            return this.moduleCode ? this.$store.getters.getTools(this.moduleCode) : {};
        },
        mapButtons() {
            let result = {};
            let tools = this.tools;
            if(tools) {
                let isMobile = detectMobile();
                Object.keys(tools).forEach(key=> {
                    let config = tools[key].display || {};
                    if(isMobile && config.mobile){
                        config = Object.assign(config, config.mobile);
                        delete config.mobile;
                    }
                    result[key] = config;
                });
            }
            return result || {};
        },
        dashboardConf() {
            return this.$root.$env.THEME.portal.dashboard;
        },
        layoutConf() {
            return this.$root.$env.THEME.layoutConfig;
        },
        occurrenceConf() {
            return this.$root.$env.THEME.map.occurrence;
        },
        workOrderConf() {
            return this.$root.$env.THEME.map.work_order;
        },
        accidentConf() {
            return this.$root.$env.THEME.map.accident;
        },
        themeLayoutConfig() {
            return this.$root.$env.THEME.layoutConfig;
        },
        mapButtonInitialCollapsed() {
            return this.mapButtons.expandcollapse.active && this.mapButtons.expandcollapse.collapsed;
        },
        chartHorizontalBar() {
            return this.$root.$env.THEME.chart.horizontalBar;
        },
    },
    methods: {
    }
}